<template>
  <div class="page-accounts">
    <div class="columns is-gapless is-vh">
      <div class="column is-2 has-background-dark">
        <Sidebar/>
      </div>

      <div class="column">
        <div class="section">
          <h1 class="title">Forms Overview</h1>

          <hr>

          <FormsOverview/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from '@/components/Sidebar.vue'
import FormsOverview from '@/components/FormsOverview.vue'

export default {
  name: 'Forms',
  components: {
    Sidebar,
    FormsOverview,
  }
}
</script>
